module.exports = __webpack_public_path__ + "media/images/lb/561-d621b85366df386c739f0e1e23ee8aeb.svg";